/* eslint-disable @typescript-eslint/no-explicit-any */
const LOG_ENDPOINT = '/api/log';
const BATCH_INTERVAL_MS = 5000;
const MAX_BATCH_SIZE = 10;

let logBuffer: any[] = [];
let timer: ReturnType<typeof setTimeout> | null = null;

function flushLogs() {
  if (logBuffer.length === 0) return;

  const logsToSend = [...logBuffer];
  logBuffer = [];

  fetch(LOG_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(logsToSend),
  });
}

function scheduleFlush() {
  if (timer) return;
  timer = setTimeout(() => {
    flushLogs();
    timer = null;
  }, BATCH_INTERVAL_MS);
}

function enqueueLog(
  level: 'info' | 'error' | 'warn' | 'log',
  message: string,
  data?: any
) {
  if (import.meta.env.VITE_VERCEL_ENV !== 'production') {
    console?.[level]?.('devlogs', message, data);
    return;
  }

  logBuffer.push({ level, message, data, timestamp: new Date().toISOString() });

  if (logBuffer.length >= MAX_BATCH_SIZE) {
    flushLogs();
    if (timer) clearTimeout(timer);
    timer = null;
  } else {
    scheduleFlush();
  }
}

export const logger = {
  log: (message: string, data?: any) => enqueueLog('log', message, data),
  error: (message: string, data?: any) => enqueueLog('error', message, data),
  warn: (message: string, data?: any) => enqueueLog('warn', message, data),
  info: (message: string, data?: any) => enqueueLog('info', message, data),
};
